import { cx } from '@/lib/cva-config'

export function Container(props: React.ComponentProps<'div'>) {
  const { className, ...rest } = props

  return (
    <div
      {...rest}
      className={cx(
        'mx-auto w-full px-4 md:px-8 2xl:max-w-screen-2xl',
        className
      )}
    />
  )
}
